import { reportSummary } from './report.js';
/** GeoJSON FeatureCollection (stringifisert) fra punkter. */
export function toGeoJSON(points) {
    return JSON.stringify({
        type: 'FeatureCollection',
        features: points.map((p) => ({
            type: 'Feature',
            geometry: { type: 'Point', coordinates: [p.lon, p.lat] },
            properties: { name: p.name, ...(p.props ?? {}) },
        })),
    }, null, 2);
}
function kx(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
/** KML-dokument fra punkter (Placemarks). Åpnes i ATAK/WinTAK/Google Earth. */
export function toKML(points, docName = 'SKADE-eksport') {
    const marks = points.map((p) => {
        const desc = Object.entries(p.props ?? {}).map(([k, v]) => `${kx(k)}: ${kx(v)}`).join('\n');
        return `  <Placemark>\n    <name>${kx(p.name)}</name>\n` +
            (desc ? `    <description>${kx(desc)}</description>\n` : '') +
            `    <Point><coordinates>${p.lon},${p.lat},0</coordinates></Point>\n  </Placemark>`;
    }).join('\n');
    return `<?xml version="1.0" encoding="UTF-8"?>\n<kml xmlns="http://www.opengis.net/kml/2.2">\n<Document>\n  <name>${kx(docName)}</name>\n${marks}\n</Document>\n</kml>`;
}
export function trackToExportPoint(t) {
    return {
        lat: t.lat, lon: t.lon, name: t.label,
        props: { kind: t.kind, affiliation: t.affiliation, sidc: t.sidc, source: t.source, ...(t.extra ?? {}) },
    };
}
export function reportToExportPoint(r) {
    return { lat: r.lat, lon: r.lon, name: `${r.type}: ${reportSummary(r)}`, props: { type: r.type, status: r.status, author: r.author } };
}
//# sourceMappingURL=export.js.map